"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enhance = exports.RequestError = void 0;
class RequestError extends Error {
    constructor(code, message = "unknown") {
        super(message);
        this.code = code;
        this.message = message;
    }
}
exports.RequestError = RequestError;
// NOTE: https://stackoverflow.com/questions/33069692/getting-a-list-of-statics-on-an-es6-class
const _blacklist = new Set(["name", "length", "prototype"]);
function* iterApi(class_) {
    for (const name of Object.getOwnPropertyNames(class_)) {
        if (!_blacklist.has(name) && typeof class_[name] === "function") {
            yield [name, class_[name]];
        }
    }
}
function enhance(service, handleError) {
    const entries = [...iterApi(service)].map(([k, api]) => {
        return [k, enhanceAPI(api, handleError)];
    });
    return Object.fromEntries(entries);
}
exports.enhance = enhance;
function enhanceAPI(api, handleError) {
    const fn = async (...args) => {
        const res = await api(...args);
        if (res.code === 200) {
            return res.data;
        }
        handleError === null || handleError === void 0 ? void 0 : handleError(res);
        throw new RequestError(res.code, res.msg);
    };
    fn.raw = api;
    return fn;
}
